/** The face of an action button: a hexagon drawn like the tile (or a round icon), its label, its cost. */
import type { JSX } from 'react';

import { hexArt } from '@ui/art/hexArt';
import { CostChips } from '@ui/components/CostChips';
import { Icon } from '@ui/icons';

import type { ActionLook } from './actionLook';

import './action.css';

export function ActionFace({ look }: { look: ActionLook }): JSX.Element {
  const { art } = look;
  return (
    <>
      {'icon' in art ? (
        <span className="ic">
          <Icon id={art.icon} />
        </span>
      ) : (
        <svg
          className="hx"
          viewBox="-38 -42 76 84"
          aria-hidden="true"
          dangerouslySetInnerHTML={{ __html: hexArt(art) }}
        />
      )}
      <span className="lbl">
        <b>{look.label}</b>
        {look.sub !== null && <small>{look.sub}</small>}
        {look.cost && <CostChips cost={look.cost.need} have={look.cost.have} mini />}
      </span>
    </>
  );
}
